import { useState } from "react";
import { addVerre } from "../services/drinkService";

function nowLocalDatetime() {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 16);
}

export default function AddDrinkForm({ alcools, onAdded }) {
  const [alcoolId, setAlcoolId] = useState(alcools[0]?.id || "");
  const [date, setDate] = useState(nowLocalDatetime());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!alcoolId) return;
    setLoading(true);
    setError("");
    try {
      await addVerre(alcoolId, date.replace("T", " ") + ":00");
      setDate(nowLocalDatetime());
      onAdded();
    } catch (err) {
      setError("Impossible d'enregistrer le verre");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="card add-drink-form" onSubmit={handleSubmit}>
      <h3>Ajouter un verre</h3>
      {error && <p className="error">{error}</p>}
      <label>
        Alcool
        <select value={alcoolId} onChange={(e) => setAlcoolId(e.target.value)}>
          {alcools.map((a) => (
            <option key={a.id} value={a.id}>
              {a.nom} — {a.categorie}
            </option>
          ))}
        </select>
      </label>
      <label>
        Date et heure
        <input
          type="datetime-local"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
      </label>
      <button type="submit" className="btn-primary" disabled={loading}>
        {loading ? "Enregistrement..." : "J'ai bu ce verre 🍻"}
      </button>
    </form>
  );
}
